import PropTypes from 'prop-types';
import React from 'react';

import { datastoreComponentConnect } from './DatastoreComponentMixin.jsx';

class ButtonCell extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired,
        basePath: PropTypes.string
    }

    handleClick(event) {
        // console.log("ButtonCell", this.context.basePath + this.props.dataPath);
        this.context.p.put(this.context.basePath + this.props.dataPath, 1, true);
    }

    render() {
        var value = this.props.data;
        var disabled = this.props.readOnly;
        if (value && this.props.data.v !== undefined) {
            // Disable if data is being stored right now
            disabled = disabled || ~~value.new;
        }

        if (disabled) {
            return (
                <button disabled="disabled" onClick={this.handleClick}>{ this.props.label }</button>
            );
        } else {
            return (
                <button  onClick={this.handleClick}>{ this.props.label }</button>
            );
        }
    }
}

export default datastoreComponentConnect(ButtonCell);